import { useMemo, useState } from "react";

import Mapwrap from "../../assets/img/Map-wrap.png";

import CardSkeleton from "../CardSkeleton";
import AddIcon from "../Icons/AddIcon";

import { useGetAllPartnerCompanyQuery } from "../../store/apiSlices/partnerCompany";

import { EditIcon, SearchIcon } from "../Icons";
import PartnerCompanyBtn from "../PartnerCompany/PartnerCompanyBtn";
import HighlightText from "../PartnerCompany/HighlightText";

export default function PartnerCompanies() {
  const {
    data: partnersData,
    isLoading,
    isError,
  } = useGetAllPartnerCompanyQuery();
  const [search, setSearch] = useState("");

  const filteredCompanies = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return partnersData;
    return partnersData?.filter((c) =>
      c.company_name?.toLowerCase().includes(term)
    );
  }, [search, partnersData]);

  return (
    <section id="dashboard-partner-companies" className="card h-[487px] col-span-full space-y-5">
      <div className="flex items-center justify-between border-b pb-2">
        <h2 className="text-[#030303] font-semibold text-xl">
          Partner Companies
        </h2>

        <PartnerCompanyBtn
          action="add"
          className="p-1 text-custom-blue-medium font-semibold border border-custom-blue-medium rounded-lg flex items-center gap-1"
        >
          <AddIcon className="size-6" />
          <span>Add New Partner</span>
        </PartnerCompanyBtn>
      </div>

      <div className="flex justify-between">
        <div>
          <img src={Mapwrap} alt="map" />
        </div>

        <div className="w-[296px] space-y-2">
          <div className="relative w-[296px]">
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 size-5" />
            <input
              type="text"
              placeholder="Search company..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="input-new !pl-10"
            />
          </div>

          <div>
            {/* === Loading State === */}
            {isLoading ? (
              <div>
                {[...Array(3)].map((_, i) => (
                  <CardSkeleton key={i} />
                ))}
              </div>
            ) : (
              /* === Success or Empty State === */
              <div className="h-[320px] overflow-y-auto custom-scrollbar divide-y divide-gray-100">
                {filteredCompanies && filteredCompanies.length > 0 ? (
                  filteredCompanies.map((el) => (
                    <div
                      key={el.partner_company_id}
                      className="flex items-center justify-between py-3 px-1 hover:bg-gray-50 transition-colors duration-150"
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-slate-200 rounded-full flex justify-center items-center font-semibold text-gray-700">
                          {el.company_name?.charAt(0)?.toUpperCase()}
                        </div>

                        <div>
                          <p className="text-sm font-medium text-gray-800">
                            <HighlightText
                              text={el.company_name}
                              query={search}
                            />
                          </p>
                          <small className="text-gray-500">
                            {el.company_registration_number || "—"}
                          </small>
                        </div>
                      </div>

                      <PartnerCompanyBtn
                        action="update"
                        selectedCompany={el}
                        className="text-custom-blue-medium font-medium text-sm hover:underline hover:scale-90 p-1 hover:bg-gray-200 rounded-md"
                      >
                        <EditIcon className="size-4" />
                      </PartnerCompanyBtn>
                    </div>
                  ))
                ) : isError ? (
                  <p className="text-center text-sm text-gray-500 py-8">
                    Failed to load partner companies.
                  </p>
                ) : (
                  <p className="text-center text-gray-500 py-10">
                    No records found
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
